import React, { useState, useCallback, useEffect } from "react";
import { Card, Box, Grid, Typography } from "@material-ui/core";
import { MutantApiService } from "../../../../services/MutantApiService";
import { StyledCardBody } from "../../components/AdminCard/style";
import { AdminTitle } from "../../components/AdminTitle";
import { BottomPageButton } from "../../../admin/components/BottomPageButton";
import { InputField } from "../../../../components/Input";
import Swal from "sweetalert2";
import Loading from "../../../home/components/Loading";
import store from "../../../../store/store";
import DatePicker from "react-datepicker";
import moment from "moment";
import { SearchSelectInput } from "../../../../components/Input/SearchSelectInput";

import "react-datepicker/dist/react-datepicker.css";
import "./CostsForm.scss";
import { titlesEnum } from "./CostsTitleEnum";
import { debounce } from "lodash";
import {
	Table,
	TableBody,
	TableCell,
	TableFooter,
	TableHead,
	TablePagination,
	TableRow,
} from "@material-ui/core";
import { StyledTableCell, StyledTableRow } from "./styles";
import { ConsolidationModal } from "./ConsolidationModal";

function format(date, pattern) {
	return moment(date).format(pattern);
}

const CostsForm = props => {
	const { auth } = store.getState();
	const [state, setState] = useState({
		id: 0,
		name: "",
		startDate: moment()
			.subtract(30, "days")
			.startOf("day")
			.toDate(),
		endDate: moment()
			.endOf("day")
			.toDate(),
		isLoading: false,
		records: 0,
		userLogged: auth.user,
		apiData: {},
		showTooltip: false,
		providerSelection: {
			label: titlesEnum.all,
			value: titlesEnum.all
		},
		recordOptions: [],
		selectedRecord: {},
		textFilter: "",
		consolidatedCostsRecords: [],
		page: 1,
		perPage: 10,
		total: 0,
		sum: 0
	});

	const api = new MutantApiService();

	useEffect(() => {
		handleSetconsolidatedCostsRecords();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [state.startDate, state.endDate, state.page]);

	const handleChangePage = (event, newPage) => {
		setState(prevState => ({
			...prevState,
			page: newPage + 1
		}));
	};

	const handleChangeRowsPerPage = event => {
		const newPerPage = parseInt(event.target.value, 10);
		setState(prevState => ({
			...prevState,
			perPage: newPerPage,
			page: 1
		}));
	};

	const handleSetconsolidatedCostsRecords = async () => {
		try {
			const formattedStartDate = moment(state.startDate).format("YYYY-MM-DD");
			const formattedEndDate = moment(state.endDate).add(1, "day").format("YYYY-MM-DD");

			let params = {
				startDate: formattedStartDate,
				endDate: formattedEndDate,
				page: state.page,
				perPage: state.perPage
			};

			if (state.providerSelection.value === titlesEnum.projeto) {
				params.idProject = state.id;
			} else if (state.providerSelection.value === titlesEnum.apikey) {
				params.idApikey = state.id;
			}

			const { data, meta, sum } = await api.makeHttpRequest({
				method: "GET",
				url: `/prompt-billing-consolidate`,
				params
			});

			setState(prevState => ({
				...prevState,
				isLoading: false,
				total: meta.total,
				consolidatedCostsRecords: data,
				sum
			}));
		} catch (error) {
			setState(prevState => ({ ...prevState, isLoading: false }));
			Swal.fire("Erro!", "Erro ao buscar dados.", "error");
		}
	};
	const [show, setShow] = useState(false);

	const fetchRecordsBase = async (endpoint, searchParam) => {
		try {
			const response = await api.makeHttpRequest({
				url: endpoint,
				method: "GET",
				params: searchParam ? { search: searchParam } : undefined
			});

			const recordOptions = response?.data?.map(record => ({
				label: endpoint === "/projects" ? `${record.name} - ${record.createdAt}` : record.service,
				value: record.id
			}));

			setState(prevState => ({
				...prevState,
				recordOptions
			}));
		} catch (error) {
			console.error("Erro ao buscar registros:", error);
		}
	};

	const fetchRecords = useCallback(
		debounce(async () => {
			const { providerSelection, textFilter } = state;
			const endpoint =
				providerSelection.value === titlesEnum.projeto
					? `/projects`
					: `/apikey`;

			fetchRecordsBase(endpoint, textFilter.trim() ? textFilter : undefined);
		}, 300),
		[state.providerSelection, state.textFilter]
	);

	const handleInputTextChange = inputText => {
		setState(prevState => ({
			...prevState,
			textFilter: inputText
		}));
	};

	const handleOptionSelect = selectedOption => {
		setState(prevState => ({
			...prevState,
			id: selectedOption?.value || null,
			textFilter: selectedOption?.label || "",
			optionSelected: {},
			recordOptions: []
		}));
	};

	useEffect(() => {
		if (state.textFilter.trim() || state.textFilter.trim() === "") {
			fetchRecords();
		}
	}, [fetchRecords, state.textFilter]);

	const fetchInitialRecords = async () => {
		fetchRecordsBase(`/projects`);
	};

	useEffect(() => {
		fetchInitialRecords();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	window.setPageTitle(`Custos consolidados de sintetização`);

	const { startDate, endDate, isLoading, consolidatedCostsRecords } = state;

	return (
		<>
			<Box
				style={{
					padding: "0 20px",
					margin: "0 auto",
					width: "100%"
				}}
			>
				<ConsolidationModal show={show} setShow={setShow} />
				<Loading isLoading={isLoading} />
				<AdminTitle
					title={`Custos consolidados de sintetização`}
					disableHeader
				/>
				<Card className="mt-4">
					<Box>
						<StyledCardBody>
							<Grid container>
								<Grid item xs={12} sm={12}>
									<Box
										style={{
											padding: 0,
											display: "flex",
											justifyContent: "start"
										}}
									>
										<Grid
											sm={12}
											container
											style={{
												display: "flex",
												justifyContent: "start",
												height: "180px"
											}}
										>
											<Grid item sm={3}>
												<Box>
													<Typography variant="h5">Filtrar por:</Typography>
													<InputField
														as="select2"
														name="searchType"
														placeholder="Escolha o tipo de busca"
														closeMenuOnSelect={false}
														value={state.providerSelection}
														options={[
															{
																label: titlesEnum.all,
																value: titlesEnum.all
															},
															{
																label: titlesEnum.apikey,
																value: titlesEnum.apikey
															},
															{
																label: titlesEnum.projeto,
																value: titlesEnum.projeto
															}
														]}
														onChange={e => {
															setState(prevState => ({
																...prevState,
																providerSelection: e,
																textFilter: "",
																id: null,
																recordOptions: []
															}));
															fetchRecordsBase(
																e.value === titlesEnum.projeto
																	? `/projects`
																	: `/apikey`
															);
														}}
													/>
												</Box>
											</Grid>
											<Grid item sm={9}>
												<Box
													style={{
														marginBottom: "30px",
														paddingLeft: "30px"
													}}
												>
													<Typography variant="h5">
														{state.providerSelection.value ===
														titlesEnum.projeto
															? "Nome do projeto"
															: state.providerSelection.value === titlesEnum.all
															? "Filtro de busca"
															: "Nome do serviço da ApiKey"}
													</Typography>
													<SearchSelectInput
														id="search-select-input"
														placeholder="Digite para buscar"
														onInputChange={handleInputTextChange}
														onChange={handleOptionSelect}
														value={{ label: state.textFilter, value: state.id }}
														options={state.recordOptions}
														isDisabled={
															state.providerSelection.value === titlesEnum.all
														}
														isClearable
													/>
												</Box>
											</Grid>
											<Grid
												item
												sm={12}
												style={{
													marginTop: "30px",
													marginBottom: "30px",
												}}
											>
													<Typography variant="h6">Período</Typography>
												<Grid sm={12} container>
													<Grid
														item
														sm={6}
														style={{
															display: "flex",
															justifyContent: "flex-start",
														}}
													>
														<Grid
															sm={12}
															md={2}
															style={{
																padding: "5px"
															}}
														>
															<Typography variant="body1">
																Inicial
															</Typography>
															<DatePicker
																selected={startDate}
																onChange={date =>
																	setState(prevState => ({
																		...prevState,
																		startDate: date
																	}))
																}
																dateFormat="dd/MM/yyyy"
																className="custom-datepicker"
															/>
														</Grid>
														<Grid
															sm={12}
															md={2}
															style={{
																padding: "5px"
															}}
														>
															<Typography variant="body1">
																Final
															</Typography>
															<DatePicker
																selected={endDate}
																onChange={date =>
																	setState(prevState => ({
																		...prevState,
																		endDate: date
																	}))
																}
																dateFormat="dd/MM/yyyy"
																className="custom-datepicker"
															/>
														</Grid>
														<Grid
															sm={12}
															md={2}
															style={{
																padding: 0
															}}
														>
															<Box
																style={{
																	display: "flex",
																	justifyContent: "flex-start",
																	padding: 0,
																	paddingLeft: "15px",
																	marginTop: "20px"
																}}
															>
																<BottomPageButton
																	variant="primary"
																	color="#9036F7"
																	type="button"
																	onClick={handleSetconsolidatedCostsRecords}
																>
																	Buscar
																</BottomPageButton>
															</Box>
														</Grid>
													</Grid>
													<Grid item sm={6}>
														<BottomPageButton
															variant="primary"
															color="#9036F7"
															type="button"
															onClick={() => setShow(true)}
															style={{
																minWidth: "200px",
																marginTop: "20px"
															}}
														>
															Consolidar Manualmente
														</BottomPageButton>
													</Grid>
												</Grid>
											</Grid>
										</Grid>
									</Box>
									<Grid
										sm={12}
										style={{
											paddingTop: "50px"
										}}
									>
										{costsTable()}
									</Grid>
								</Grid>
								<Grid
									sm={12}
									style={{
										padding: "5px",
										border: "1px solid #E5E5E5",
										borderRadius: "4px",
										marginTop: "30px"
									}}
								>
									<Typography
										variant="h4"
										style={{
											marginBottom: "30px"
										}}
									>
										Valor total:{" "}
										<b>
											{state?.sum.toLocaleString("pt-br", {
												style: "currency",
												currency: "BRL"
											})}
										</b>
									</Typography>
								</Grid>
							</Grid>
						</StyledCardBody>
					</Box>
				</Card>
			</Box>
		</>
	);

	function costsTable() {
		return (
			<Box
				style={{
					marginTop: "30px",
				}}
			>
				<Typography variant="h4" gutterBottom>
					Custos Consolidados
				</Typography>
				{state.isLoading ? (
					<Loading isLoading={state.isLoading} />
				) : (
					<>
						<Table size="small">
							<TableHead>
								<TableRow>
									<TableCell>Nome do Projeto/Serviço da ApiKey</TableCell>
									<TableCell>Data de Referência</TableCell>
									<TableCell>Valor</TableCell>
									<TableCell>Quantidade de Caracteres</TableCell>
									<TableCell>Tipo</TableCell>
								</TableRow>
							</TableHead>
							<TableBody>
								{consolidatedCostsRecords.map(row => (
									<StyledTableRow key={row.id}>
										<StyledTableCell>
											{row?.project?.name || row?.apikey?.service}
										</StyledTableCell>

										<StyledTableCell>
											{format(new Date(row.consolidationDate), "DD/MM/YYYY")}
										</StyledTableCell>
										<StyledTableCell>
											{new Intl.NumberFormat("pt-BR", {
												style: "currency",
												currency: "BRL"
											}).format(row.price)}
										</StyledTableCell>
										<StyledTableCell>{row.characterCount}</StyledTableCell>
										<StyledTableCell>
											{row.type === "FILE" ? "Arquivo" : "Streaming"}
										</StyledTableCell>
									</StyledTableRow>
								))}
							</TableBody>
							<TableFooter>
								<TableRow>
									<TablePagination
										rowsPerPageOptions={[10, 25, 50]}
										count={state.total}
										rowsPerPage={state.perPage}
										page={state.page - 1}
										onChangePage={handleChangePage}
										onChangeRowsPerPage={handleChangeRowsPerPage}
									/>
								</TableRow>
							</TableFooter>
						</Table>
					</>
				)}
			</Box>
		);
	}
};

export default CostsForm;
